import React from "react"
import SbEditable from "storyblok-react"
import { renderBlog } from 'route/Landing/sections/08_OurBlog'
import { __ } from 'utils/i18n'

const PostsList = ({ blok, t }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="container mx-auto">
      <section className="post-list row sec-pad-std fade-in">
        <div className="col-md-4">
        <header className="sec-pad-std">
              <h1>{__('Our blog', t)}</h1>
            <p className="mb-4">{__('Intro Subtitle', t)}</p>
            <a href="https://app.farmair.io/signup" className="m-btn m-btn-green">
              {__('Create Account', t)}
            </a>
          </header>
        </div>
        <div className="col-md-8">
          <div className="row">
          {blok.posts.map(post => {
            let post1 = {
              ...post,
              field_image_string: post.content.image,
              field_intro_string: post.content.intro
            }
            return renderBlog(post1, 'col-sm-12 col-xl-6 mb-4')
          })}
        </div>
        </div>
      </section>

      </div>
    </SbEditable>
  )
}

export default PostsList
